export default __webpack_public_path__ + "static/media/icons8-python.630e0d30.gif";